module.exports = __webpack_public_path__ + "static/media/digital-key_1.dca7a20c.svg";